module.exports = __webpack_public_path__ + "img/station-icon_5.7258d400.png";